import routes from '@/constants/routes';
import { Menu } from '@/types';
import {
  ButtonBase,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { CircleArrowRight } from 'lucide-react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

const MenuCard = ({ id, image, title, description, flow }: Menu) => {
    const navigate = useNavigate();
    const { organizationAlias } = useParams<{ organizationAlias: string }>();
    
    const goToMenu = () => {
        const path = generatePath(routes.organizations.menu.read, { organizationAlias, menuId: id });
        const qs = new URLSearchParams(window.location.search);
        qs.set('flow', flow.toString());
        navigate(path + '?' + qs.toString());
    };

    return (
        <Card>
            <ButtonBase
            sx={{ width: '100%' }}
            onClick={goToMenu}
            component="div"
            >
            <Stack
                direction="row"
                padding={1}
                spacing={2}
                alignItems="center"
                flex={1}
            >
                <CardMedia
                component="img"
                image={Array.isArray(image) ? image[0] : (image ?? '/placeholder.png')}
                sx={{
                    width: '75px',
                    height: '75px',
                    borderRadius: 0.5,
                }}
                />
                <CardContent
                sx={{ width: '100%', textAlign: 'left', padding: 0 }}
                >
                {title ? (
                    <Typography fontSize={'20px'}>
                    {title}
                    </Typography>
                ) : null}
                {description ? (
                    <Typography variant="body1" color="text.secondary">
                    {description}
                    </Typography>
                ) : null}
                </CardContent>
                <CardActions disableSpacing>
                <IconButton color="primary">
                    <CircleArrowRight />
                </IconButton>
                </CardActions>
            </Stack>
            </ButtonBase>
        </Card>
    )
}

export default MenuCard;
